import React from 'react';

export default function HeaderProgresso({ empresa, percentual, onSair }) {
  const cor = percentual >= 80 ? 'bg-green-500' : percentual >= 40 ? 'bg-brand-600' : 'bg-amber-500';
  const label = percentual >= 100 ? '🎉 Configuração concluída!' : `${percentual}% da configuração preenchida`;

  return (
    <header className="bg-white border-b border-gray-100 sticky top-0 z-30">
      {/* Barra superior */}
      <div className="flex items-center justify-between px-6 py-3 gap-4">
        <div className="flex items-center gap-3">
          <img src="/logo_ht.png" alt="HeadThink" className="h-8 w-auto" />
          <div className="hidden sm:block h-6 w-px bg-gray-200" />
          <div className="hidden sm:block">
            <p className="text-xs text-gray-400 leading-none">Portal de Onboarding</p>
            <p className="text-sm font-semibold text-gray-800 leading-tight">{empresa}</p>
          </div>
        </div>
        <button onClick={onSair} className="btn-ghost text-xs">
          <svg className="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1" />
          </svg>
          Sair
        </button>
      </div>

      {/* Barra de progresso */}
      <div className="px-6 pb-3">
        <div className="flex items-center justify-between mb-1.5">
          <span className="text-xs font-medium text-gray-600">{label}</span>
          <span className="text-xs font-bold text-brand-700">{percentual}%</span>
        </div>
        <div className="w-full bg-gray-100 rounded-full h-2">
          <div
            className={`h-2 rounded-full transition-all duration-700 ${cor}`}
            style={{ width: `${percentual}%` }}
          />
        </div>
      </div>
    </header>
  );
}
